import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';
import './myidcards.scss';

const MyIDCardSkeleton = () => {
  return (
    <>
      <Col xs={12} className="idcard-skelton">
        <Row className="mt-5">
          <Col sm={4}>
            <Card className="p-3">
              <Skeleton count={5} height={12} className="Id-Card-Image" />
            </Card>
          </Col>
          <Col sm={4}>
            <Card className="p-3">
              <Skeleton count={5} height={12} className="Id-Card-Image" />
            </Card>
          </Col>
        </Row>
        <Row className="mt-4 mb-4">
          <Col>
            <Skeleton count={1} height={12} className="Id-Card-Text" />
          </Col>
        </Row>

        <Row className="mb-3 mt-4">
          <Col sm={4}>
            <Row>
              <Col sm={9}>
                <Card className="p-3">
                  <Skeleton count={1} height={25} className="Id-Card-Image" />
                </Card>
              </Col>
              <Col sm={3}>
                <Card className="p-3">
                  <Skeleton count={1} height={25} className="Id-Card-Image" />
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col className="px-0">
            <div className="newidcard col">
              <h4 className="replacementCard_info">
                <Skeleton count={1} height={20} />
              </h4>
              <div className="replacementCard_info" aria-live="polite">
                <Skeleton count={4} height={12} />
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default MyIDCardSkeleton;
